import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useWorkspaceDeveloperDeliveryStatsQuery.ts
var r = (r, i = !0) => t({
	queryKey: e.deliveryStats(r),
	queryFn: () => n.deliveryStats(r),
	enabled: i
});
//#endregion
export { r as useWorkspaceDeveloperDeliveryStatsQuery };
